import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import CompanyHero from './components/CompanyHero';
import CompanyHistory from './components/CompanyHistory';
import CompanyValues from './components/CompanyValues';
import CompanyServices from './components/CompanyServices';
import CompanyPartners from './components/CompanyPartners';
import usePageMeta from '@/hooks/usePageMeta';

const UeberUnsPage = () => {
  usePageMeta({
    title: 'Über uns – Inhabergeführter Maschinenbau seit 1992 | gowiTEC Reichshof',
    description: 'gowiTEC ist ein inhabergeführtes Unternehmen für Sondermaschinenbau und Automatisierungstechnik in Reichshof-Wehnrath. Über 30 Jahre Erfahrung, 500+ realisierte Projekte.',
    keywords: 'gowiTEC Unternehmen, Maschinenbau Reichshof, Automatisierung NRW, inhabergeführt, Unternehmensgeschichte',
    canonical: 'https://gowitec.de/ueber-uns',
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <CompanyHero />
        <CompanyValues />
        <CompanyHistory />
        <CompanyServices />
        <CompanyPartners />

        {/* CTA */}
        <section className="py-20 bg-[#1E3A8A]">
          <div className="max-w-7xl mx-auto px-6 md:px-10 text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Bereit für Ihr nächstes Projekt?
            </h2>
            <p className="text-blue-200 text-lg mb-8 max-w-xl mx-auto">
              Kontaktieren Sie uns – wir beraten Sie kostenlos und unverbindlich zu Ihrer Automatisierungsaufgabe.
            </p>
            <Link
              to="/anfrage"
              className="inline-flex items-center gap-2 bg-[#DC2626] hover:bg-[#b91c1c] text-white font-semibold px-8 py-4 rounded-md transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              Jetzt Projekt anfragen
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
            </Link>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default UeberUnsPage;
